import {useContext, useEffect, useState} from "react";
import {NavLink} from "react-router-dom";

// Global state
import {UserAuthenticationContext} from "../../Context/UserAuthenticationContext";

// Assets
import {IckonicLogo} from "../../Assets/SVGs/Logos";
import PlayButtonFractalLines from "../../Assets/SVGs/PlayButtonFractalLines";
import IconQuestionFilled from "../../Assets/SVGs/Icons/AlertAndInfo/QuestionFilled";

// Components
import SinglePlanInfo from "../../Components/Layouts/Plans/SinglePlanInfo";
import ButtonPill from "../../Components/Buttons/ButtonPill";

// Constants
import {RoutePaths} from "../../Constants/RoutePaths";

// Helpers
import {SetTitle} from "../../Helpers/PageMetadata";

// Hooks
import useFetchUserSubscription from "../../Hooks/User/useFetchUserSubscription";
import {IsSubscriptionActive} from "../../Helpers/Subscription";

const SignUpSuccess = () => {
    const
        {userData, doesAuthTokenExist, getValidAccessToken} = useContext(UserAuthenticationContext),
        [isLoading, setIsLoading] = useState<boolean>(true),
        {subscriptionData} = useFetchUserSubscription({getValidAccessToken, userId: userData?.id});

    useEffect(() => {
        if (userData?.email) {
            setIsLoading(false);
        }
    }, [userData]);

    useEffect(() => {
        SetTitle("Welcome to the family!");
        window.scrollTo({ top: 0, behavior: "auto" }); // You could also use 'smooth' if you want a scroll animation

        // console.log(`!doesAuthTokenExist() ${!doesAuthTokenExist()}`);
        // console.log(`!IsSubscriptionActive(subscriptionData?.Status) ${!IsSubscriptionActive(subscriptionData?.Status)}`);
        // console.log(`subscriptionData?.Status ${subscriptionData?.Status}`);

        // redirect unqualified users
        // if (!doesAuthTokenExist() || !IsSubscriptionActive(subscriptionData?.Status)) {
        //     window.location.href = "/sign-up";
        // }
    }, []);

    return (
        <div className={`page page--sign-up-success page--no-nav ${isLoading ? 'is-loading' : 'is-not-loading'} is-dark-mode`}>
            <div className="page__header">
                <NavLink to='/'>
                    {IckonicLogo()}
                </NavLink>
            </div>

            <div className="page__heading u-relative_hidden has-light-mode">
                <h1>
                    Welcome to the Ickonic
                    Family, {isLoading ?
                    <span className="u-relative_hidden sign-up-success__loader">
                        <span className="u-full_cover_absolute loader--side-to-side"/>
                    </span>
                    :
                    `${(userData?.first_name || "First Name")}!`}
                </h1>

                {PlayButtonFractalLines()}
            </div>

            <div className="page__inner">
                <p>
                    A confirmation email has been sent to:
                    {
                        isLoading ?
                            <span className="u-relative_hidden sign-up-success__loader">
                            <span className="u-full_cover_absolute loader--side-to-side"/>
                        </span>
                            :
                            <span className="page__text-highlight">{(userData?.email || "you@example.com")}</span>
                    }
                </p>

                <SinglePlanInfo
                    authUser={userData}
                    sub={subscriptionData}
                />

                <p className="page__help-text">
                    {IconQuestionFilled()}
                    <span>If you have any questions, visit our <NavLink to={RoutePaths.HelpCentre}>Help Centre</NavLink> to contact customer support or check out our FAQs</span>
                </p>

                <div className="page__button-wrapper">
                    <ButtonPill label="Start Watching" link={RoutePaths.Browse}/>
                    <ButtonPill label="Start Watching" className="u-full_cover_absolute" link={RoutePaths.Browse}/>
                </div>
            </div>
        </div>
    );
};

export default SignUpSuccess;
